import {
  Box,
  Button,
  Card,
  Modal,
} from "@mui/material";
import React from "react";
import { colors } from "../../values/colors";

import { useGetAllRolesQuery } from "../../services/auctionAPI";
import PlayerAuctionCard from "../PlayerAuctionCard";

const ProfileModal = ({ open, onClose, profile, player, isJitoTournament, playerNumber }) => {
  const { data: rolesData } = useGetAllRolesQuery();
  const roles = rolesData?.data || [];

  const roleName = roles?.find(
    (r) => r?._id === player?.playerId?.roleId
  )?.name;



  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Card
        sx={{
          width: 1100,
          p: 3,
          borderRadius: "16px",
          boxShadow: "0px 4px 25px rgba(0,0,0,0.15)",
          textAlign: "left",
        }}
      >
        <PlayerAuctionCard
          player={player}
          playerNumber={playerNumber}
          roleName={roleName}
          isJitoTournament={isJitoTournament}
          showVisibilityIcon={false}
        />
        <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
          <Button
            variant="contained"
            onClick={onClose}
            sx={{
              background: colors.linearGradent,
              color: "#fff",
              textTransform: "none",
              borderRadius: "999px",
              width: "9rem",
              paddingY: ".5rem",
            }}
          >
            Close
          </Button>
        </Box>
      </Card>
    </Modal>
  );
};

export default ProfileModal;
